module.exports = __webpack_public_path__ + "static/media/strava-synchronise.44c1ba13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/strava-synchronise.svg
// module id = 724
// module chunks = 0